import { render, staticRenderFns } from "./inactive-student.vue?vue&type=template&id=ffba03ce&scoped=true&"
import script from "./inactive-student.vue?vue&type=script&lang=js&"
export * from "./inactive-student.vue?vue&type=script&lang=js&"
import style0 from "./inactive-student.vue?vue&type=style&index=0&id=ffba03ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffba03ce",
  null
  
)

export default component.exports